const TeamData = {
    TeamMembers: [
        {
            id:1,
            name:"Jennifer Ikra",
            position:"Head of Idea",
            imgUrl:"1",

            socialIcon:[
                {
                  id: 1,
                  url: 'https://www.facebook.com/',
                  icon: 'fab fa-facebook-f',
                },
                {
                  id: 2,
                  url: '.#',
                  icon: 'fab fa-twitter',
                },
                {
                  id: 3,
                  url: '.#',
                  icon: 'fab fa-dribbble',
                },
                {
                  id: 4,
                  url: '.#',
                  icon: 'fab fa-linkedin-in',
                }
            ],
        },
        {
            id:2,
            name:"Azizul Haque",
            position:"CEO and Founder",
            imgUrl:"2",

            socialIcon:[
                {
                  id: 1,
                  url: 'https://www.facebook.com/',
                  icon: 'fab fa-facebook-f',
                },
                {
                  id: 2,
                  url: '.#',
                  icon: 'fab fa-twitter',
                },
                {
                  id: 3,
                  url: '.#',
                  icon: 'fab fa-dribbble',
                },
                {
                  id: 4,
                  url: '.#',
                  icon: 'fab fa-linkedin-in',
                }
            ],
        },
        {
            id:3,
            name:"Jennifer Dumas",
            position:"UI/UX Designer",
            imgUrl:"3",

            socialIcon:[
                {
                  id: 1,
                  url: 'https://www.facebook.com/',
                  icon: 'fab fa-facebook-f',
                },
                {
                  id: 2,
                  url: '.#',
                  icon: 'fab fa-twitter',
                },
                {
                  id: 3,
                  url: '.#',
                  icon: 'fab fa-dribbble',
                },
                {
                  id: 4,
                  url: '.#',
                  icon: 'fab fa-linkedin-in',
                }
            ],
        },
        {
            id:4,
            name:"Nuorin Janu",
            position:"Full Statck Dev",
            imgUrl:"4",

            socialIcon:[
                {
                  id: 1,
                  url: 'https://www.facebook.com/',
                  icon: 'fab fa-facebook-f',
                },
                {
                  id: 2,
                  url: '.#',
                  icon: 'fab fa-twitter',
                },
                {
                  id: 3,
                  url: '.#',
                  icon: 'fab fa-dribbble',
                },
                {
                  id: 4,
                  url: '.#',
                  icon: 'fab fa-linkedin-in',
                }
            ]
        },

    ],

}


export default TeamData
